import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import comment from '../../img/comment.png';
import attach from '../../img/attach.png';
import info from '../../img/station-info-icon.png';
import { Table, Popover, Menu, Dropdown, notification, Drawer, Tag } from 'antd';
import { stationFilter } from '../../data/stationdetaildata';
import { updateChecklist } from '../../services/station.service';
import moment from 'moment';
import { activateChecklist } from '../../services/menu.service';
import { updateItem } from '../../services/checklist.service';
import {
  addItem as addItemToShop,
  itemNeeded as revertItem,
  itemOrdered,
  deleteStationItems as removeFromShop,
  deleteItem, // BUG 1201998443633183
} from '../../services/shoplist.service';
import { cloneDeep, find, remove, findIndex, isEmpty } from 'lodash';
import useWindowSize from '../../components/windowdimensions/windowSize';
import DocumentList from '../../components/DocumentList/DocumentList';
import RoleAccessibleComponent from '../../components/RoleAccess/roleaccess';
import { REACT_APP_SOCKET_BASE_URL } from '../../config';
import openSocket from 'socket.io-client';
import {
  CidekicButton,
  PlusButton,
  CidekicDropdown,
  AttachmentIndicator,
  CompletionIcon,
  HealthcheckIcon,
  ShoppingCartIcon,
  ThumbnailImage,
  CookbookIcon,
  ChefIcon,
} from '../../components/common/common_ui';
import { ConsoleSqlOutlined } from '@ant-design/icons';

const StationFiltered = (props) => {
  const {
    progressOpen,
    stationDetail,
    stationIngs,
    stationIng,
    tableData,
    showAllIngredients,
    filterCompletedHealthChecks,
    filterProductionReady,
    filterCompleted,
    filterNeeded,
    updateIngredientsState,
    updateDocumentsState,
    updateTaskState,
    showSingleList,
    activateChecklists,
    assignedToMe,
    setHasUpdate,
    hasUpdateChecklist,
    documents,
    stationId,
    stationType,
    stationName,
    setEventChecklistFiltered,
    selectedId,
    pristineIngs,
    setPristineIngs,
  } = props;
  const [menuName, setMenuName] = useState('');
  const [userInfo, setUserInfo] = useState({});
  const [selectedList, setSelectedList] = useState({});
  const [selectedList2, setSelectedList2] = useState([]);
  const [showTiles, setShowTiles] = useState(false);
  const [visible, updateVisible] = useState(false);
  const [visible1, updateVisible1] = useState(false);
  const [docLinks, setDocLinks] = useState({});
  const [links, setLinks] = useState({});
  const [links1, setLinks1] = useState({});
  const [docLinks1, setDocLinks1] = useState({});
  const [pristineList, setPristineList] = useState([]);
  const [pristineLists, setPristineLists] = useState([]);
  const [eventSocket] = useState(() => openSocket(`${REACT_APP_SOCKET_BASE_URL}/checklist`));
  const [sortedInfo, setSortedInfo] = useState({});

  const windowSize = useWindowSize();

  const restaurantId = (JSON.parse(localStorage.getItem('restaurant')) || {}).id;
  let userRole = (JSON.parse(localStorage.getItem('operator')) || {}).role;

  useEffect(() => {
    setUserInfo(JSON.parse(localStorage.getItem('operator')) || {});
  }, []);

  useEffect(() => {
    console.log('SHOW RECIPE', tableData);
    console.log('SHOWLIST', showSingleList);
    console.log('LISTACTIVATED', activateChecklists);
    let activeIds = showSingleList.key;
    console.log('!!!!ACTIVEIDSSS', activeIds);
    console.log('STATIONING', stationIng);

    let stationLists = stationIngs.filter((s) => s.key === activeIds);
    let stationLists2 = stationIng.filter((s) => s.key === activeIds);

    console.log('STATIONINGS', stationIngs);
    console.log('STATIONLISTS', stationLists);

    if (stationIngs.length == 1) {
      setSelectedList(stationIngs);
      setPristineLists(stationIngs);
    } else {
      setSelectedList(stationLists);
    }

    if (stationIng.length == 1) {
      setSelectedList2(stationIng);
      setPristineList(stationIng);
    } else {
      setSelectedList2(stationLists2);
    }

    console.log('!!!SELECTEDLIST', stationLists);
  }, [showSingleList, tableData]);

  const filterHealthComplete = () => {
    //
    filterCompletedHealthChecks();
    setMenuName('Quality check incomplete');
  };

  const filterComplete = () => {
    filterCompleted();
    setMenuName('Production completed');
  };

  const filterShowAll = () => {
    showAllIngredients();
    setMenuName('All ingredients');
  };

  const filterProductionReady1 = () => {
    filterProductionReady();
    setMenuName('Production ready');
  };

  const filteringIncomplete = () => {
    let list = cloneDeep(pristineList);
    list.forEach((o) => {
      o.children = o.children.filter((s) => s.complete == 1);
    });
    console.log(list);
    setSelectedList2(list);
    setMenuName('Items incomplete');
  };

  const filterComplete1 = () => {
    let list1 = cloneDeep(pristineList);
    console.log(list1);
    list1.forEach((o) => {
      o.children = o.children.filter((s) => s.complete == 2);
    });
    setSelectedList2(list1);
    setMenuName('Items completed');
  };

  const filterShop = () => {
    filterNeeded();
    setMenuName('Shopping list');
  };

  const menu = (
    <Menu className="menu-show-preview">
      <Menu.Item className="menu-show-preview">
        <span onClick={filterShowAll}>All ingredients</span>
      </Menu.Item>
      <Menu.Item className="menu-show-preview">
        <span onClick={filterHealthComplete}>Quality check incomplete</span>
      </Menu.Item>
      <Menu.Item className="menu-show-preview">
        <span onClick={filterProductionReady1}>Production ready</span>
      </Menu.Item>
      <Menu.Item className="menu-show-preview">
        <span onClick={filterComplete}>Production completed</span>
      </Menu.Item>
      <Menu.Item className="menu-show-preview">
        <span onClick={filterShop}>Shopping list</span>
      </Menu.Item>
    </Menu>
  );

  const menu1 = (
    <Menu className="menu-show-preview">
      <Menu.Item className="menu-show-preview">
        <span onClick={() => window.location.reload()}>All items</span>
      </Menu.Item>
      <Menu.Item className="menu-show-preview">
        <span onClick={filteringIncomplete}>Items incomplete</span>
      </Menu.Item>
      <Menu.Item className="menu-show-preview">
        <span onClick={filterComplete1}>Items completed</span>
      </Menu.Item>
    </Menu>
  );

  const columnChecklist = [
    {
      title: () => {
        return <div>&#10003;</div>;
      },
      className: 'align-center',
      dataIndex: 'completed',
      sorter: (a, b) => (a.complete < b.complete ? -1 : a.complete > b.complete ? 1 : 0),
      sortDirections: ['descend', 'ascend'],
      width: '5%',
      render: (key, obj) => (
        <span>
          {obj.type == 'child' && (
            <span className="station-checkmark-icon" onClick={() => setCompleteTask(obj, true)}>
              <CompletionIcon completed={obj.complete === 2} dimmed={false} />
            </span>
          )}
        </span>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '30%',
      sorter: (a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0),
      sortDirections: ['ascend', 'descend'],
      sortOrder: sortedInfo?.columnKey == 'name' && sortedInfo?.order,
      render: (key, obj) => (
        <span className="name-key">
          {obj.type == 'child' && (
            <div className="station-name-key">
              <div className="station-day-ing"></div>
              <div className="station-ingredient-title">{key}</div>
              <span>
                {obj.type == 'child' && obj.texts > 0 ? <span className="texts">{obj.texts}</span> : ''}
                {obj.type == 'child' && obj.texts > 0 ? (
                  <span className="texts-icon">
                    {' '}
                    <img src={attach} className="comment" alt="comment" />
                  </span>
                ) : (
                  ''
                )}
                {obj.type == 'child' && obj.attachments > 0 ? (
                  <span className={obj.texts > 0 ? 'attachments' : 'attachments1'}>{obj.attachments}</span>
                ) : (
                  ''
                )}
                {obj.type == 'child' && obj.attachments > 0 ? (
                  <span className={'texts-icon'}>
                    {' '}
                    <img src={attach} className="comment" alt="attach" />
                  </span>
                ) : (
                  ''
                )}
              </span>
            </div>
          )}
          {obj.type == 'parent' && (
            <span className="row-parent-title">
              {key} <div className="station-ing-totals">( {obj.ingredients} items )</div>
            </span>
          )}
        </span>
      ),
    },
    {
      title: 'Assignee',
      dataIndex: 'assignee',
      width: '20%',
      render: (key, obj) => (
        <span className="name-key">
          {obj.type == 'child' && (
            <div className="station-name-key">
              <div className="station-day-ing"></div>
              <div className="station-ingredient-title">{key}</div>
            </div>
          )}
        </span>
      ),
    },
    {
      title: 'Due date',
      dataIndex: 'dueDate',
      width: '10%',
      render: (key, obj) => (
        <span className="name-key">
          {obj.type == 'child' && (
            <div className="station-name-key">
              <div className="station-day-ing"></div>
              <div className="station-ingredient-title">
                {obj.dueDate && !obj.dueDate.includes('1970')
                  ? moment.utc(obj.dueDate).format('MM/DD/YYYY')
                  : 'No date'}
              </div>
            </div>
          )}
        </span>
      ),
    },
    {
      title: 'Project',
      dataIndex: 'project',
      width: '10%',
      render: (key, obj) => (
        <span className="name-key">
          {obj.type == 'child' && (
            <div className="station-name-key">
              <div className="station-day-ing"></div>

              <div className="station-ingredient-title">{key}</div>
            </div>
          )}
        </span>
      ),
    },
    // {
    //   title: 'Tags',
    //   dataIndex: 'tags',
    //   width: '15%',
    //   render: (tags, obj) => (
    //     <div className="checklist-taggy">
    //       {obj.type == 'child' && tags
    //         ? tags.map((tag) => {
    //             let color = 'black';
    //             return (
    //               <Tag color={color} key={tag}>
    //                 {tag}
    //               </Tag>
    //             );
    //           })
    //         : ''}{' '}
    //     </div>
    //   ),
    // },
    {
      title: 'Priority',
      dataIndex: 'priority',
      width: '15%',
      render: (key, obj) => (
        <span className="flex">
          {obj.type == 'child' && (
            <div className="station-name-key">
              <div className="station-day-ing"></div>
              <div className="station-ingredient-title">
                {obj.priority == 'High' && <span className="priorities high">{key}</span>}
                {obj.priority == 'Medium' && <span className="priorities med">{key}</span>}
                {obj.priority == 'Low' && <span className="priorities low">{key}</span>}
              </div>
            </div>
          )}
        </span>
      ),
    },
  ];

  const columns = [
    {
      title: 'Ingredient',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      sorter: (a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0),
      sortDirections: ['ascend', 'descend'],
      sortOrder: sortedInfo?.columnKey == 'name' && sortedInfo?.order,
      render: (key, obj) => (
        <span>
          <div className="station-name-key">
            <RoleAccessibleComponent
              permittedRoles={['Chef', 'Admin', 'Superadmin', 'Client Admin', 'Dev Team', 'Account Holder']}
            >
              <div className="station-day-ing">
                {obj.day && obj.day !== 'Invalid date' ? (
                  <div
                    onClick={(e) =>
                      userRole == 'Cook' || userRole == 'Trainer / Manager' || userRole == 'Front House'
                        ? ''
                        : unsetDay(obj)
                    }
                  >
                    {obj.day == 'Friday' && <div className="station-set-days set-day-fri set-day-orient">FRI</div>}
                    {obj.day == 'Thursday' && <div className="station-set-days set-day-thu set-day-orient">THU</div>}
                    {obj.day == 'Tuesday' && <div className="station-set-days set-day-tue set-day-orient">TUE</div>}
                    {obj.day == 'Wednesday' && <div className="station-set-days set-day-wed set-day-orient">WED</div>}
                    {obj.day == 'Monday' && <div className="station-set-days set-day-mon set-day-orient">MON</div>}
                    {obj.day == 'Sunday' && <div className="station-set-days set-day-sun set-day-orient">SUN</div>}
                    {obj.day == 'Saturday' && <div className="station-set-days set-day-sat set-day-orient">SAT</div>}
                  </div>
                ) : (
                  <div
                    className="station-set-days set-day set-day-orient"
                    onClick={(e) =>
                      userRole == 'Trainer / Manager' || userRole == 'Front House' ? '' : setActiveDay(obj)
                    }
                  >
                    SET
                  </div>
                )}
                <Popover
                  content={
                    <div className="day-infoPop">
                      {obj.day && obj.day !== 'Invalid date' ? (
                        <div>
                          <div style={{ marginBottom: 3 }}>
                            <b>Recorded by</b>
                          </div>
                          <p>{obj.setBy}</p>
                          <div style={{ marginBottom: 3 }}>
                            <b>Date</b>
                          </div>
                          <p>{obj.setDate}</p>
                          <div style={{ marginBottom: 3 }}>
                            <b>Time</b>
                          </div>
                          <p>{obj.setTime}</p>
                        </div>
                      ) : (
                        <div>This will display the name, date and time of when the day dot is set</div>
                      )}
                    </div>
                  }
                >
                  <div className="station-infoIcon">
                    <img className="station-infoIconImg" src={info} alt="info" />
                  </div>
                </Popover>
              </div>
            </RoleAccessibleComponent>
            <ThumbnailImage
              className="station-ingredient-image-container"
              src={obj.ingredientImage ? obj.ingredientImage : null}
              placeholderIcon={<ChefIcon />}
            />
            <div className="station-ingredient-title-container">
              <div className="station-ingredient-title">{key}</div>
              <div className="station-ingredient-measure">{`${obj.formattedQty} ${obj.measurementName !== 'nomeas' ? obj.measurementName : ''}`}</div>
              {obj.preparationName ? (
                <div className="station-ingredient-preparation">
                  {obj.preparationName}
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </span>
      ),
    },
    // {
    //   title: 'Qty',
    //   dataIndex: 'ingredientQty',
    //   key: 'ingredientQty',
    //   className: 'align-right',
    //   width: 70,
    //   sorter: (a, b) => parseFloat(a.ingredientQty) - parseFloat(b.ingredientQty),
    //   sortDirections: ['descend', 'ascend'],
    //   sortOrder: sortedInfo?.columnKey == 'ingredientQty' && sortedInfo?.order,
    //   render: (key, obj) => <span className="station-name-filter">{key !== null ? formatIfNeeded(key) : ''}</span>,
    // },
    // {
    //   title: 'Measurement',
    //   dataIndex: 'measurementName',
    //   width: 120,
    //   key: 'measurementName',
    //   //className: 'align-center',
    //   sorter: (a, b) =>
    //     a.measurementName.toLowerCase() < b.measurementName.toLowerCase()
    //       ? -1
    //       : a.measurementName.toLowerCase() > b.measurementName.toLowerCase()
    //       ? 1
    //       : 0,
    //   sortDirections: ['descend', 'ascend'],
    //   sortOrder: sortedInfo?.columnKey == 'measurementName' && sortedInfo?.order,
    //   render: (key, obj) => <span className="station-name-filter">{key}</span>,
    // },
    // {
    //   title: 'Preparation',
    //   dataIndex: 'preparationName',
    //   width: 110,
    //   key: 'preparationName',
    //   //className: 'align-center',
    //   sorter: (a, b) =>
    //     a.preparationName.toLowerCase() < b.preparationName.toLowerCase()
    //       ? -1
    //       : a.preparationName.toLowerCase() > b.preparationName.toLowerCase()
    //       ? 1
    //       : 0,
    //   sortDirections: ['descend', 'ascend'],
    //   sortOrder: sortedInfo?.columnKey == 'preparationName' && sortedInfo?.order,
    //   render: (key, obj) => <span className="station-name-filter">{key}</span>,
    // },
    {
      title: 'Quality check',
      dataIndex: 'healthCheck',
      width: 60,
      key: 'healthCheck',
      className: 'align-center',
      sorter: (a, b) => (a.healthCheck < b.healthCheck ? -1 : a.healthCheck > b.healthCheck ? 1 : 0),
      sortDirections: ['descend', 'ascend'],
      sortOrder: sortedInfo?.columnKey == 'healthCheck' && sortedInfo?.order,
      render: (key, obj) => (
        <span>
          {obj.type == 'child' && key ? (
            <span className="station-healthcheck-icon" alt="healthcheck" onClick={(e) => toggleHealth(e, obj)}>
              <HealthcheckIcon completed={key === 2} dimmed={false} />
            </span>
          ) : (
            ''
          )}
        </span>
      ),
    },
    {
      title: 'Completed',
      dataIndex: 'completed',
      width: 60,
      key: 'completed',
      className: 'align-center',
      sorter: (a, b) => (a.completed < b.completed ? -1 : a.completed > b.completed ? 1 : 0),
      sortDirections: ['descend', 'ascend'],
      sortOrder: sortedInfo?.columnKey == 'completed' && sortedInfo?.order,
      render: (key, obj) => (
        <span>
          <span>
            {/* <img
              alt="completed"
              style={{ cursor: 'pointer' }}
              height="38"
              onClick={(e) => toggleCompleted(e, obj)}
              src={key === 2 ? completed3 : obj.healthCheck === 2 ? completed2 : completed1}
            /> */}
            {key === 2 && (
              <span className="station-checkmark-icon" onClick={(e) => toggleCompleted(e, obj)}>
                <CompletionIcon completed={true} dimmed={false} />
              </span>
            )}
            {obj.healthCheck === 2 && key !== 2 && (
              <span className="station-checkmark-icon" onClick={(e) => toggleCompleted(e, obj)}>
                <CompletionIcon completed={false} dimmed={false} />
              </span>
            )}
            {obj.healthCheck !== 2 && key !== 2 && (
              <span className="station-checkmark-icon">
                <CompletionIcon completed={false} dimmed={true} />
              </span>
            )}
          </span>
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div>
            <RoleAccessibleComponent
              permittedRoles={[
                'Chef',
                'Admin',
                'Superadmin',
                'Client Admin',
                'Dev Team',
                'Account Holder',
                'Billing',
                'Buyer',
              ]}
            >
              <div>Needed</div>
            </RoleAccessibleComponent>
          </div>
        );
      },
      dataIndex: 'ordered',
      width: 60,
      className: 'align-center',
      sorter: (a, b) => (a.needed < b.needed ? -1 : a.needed > b.needed ? 1 : 0),
      sortDirections: ['descend', 'ascend'],
      render: (key, obj) => (
        <RoleAccessibleComponent
          permittedRoles={[
            'Chef',
            'Admin',
            'Superadmin',
            'Client Admin',
            'Dev Team',
            'Account Holder',
            'Billing',
            'Buyer',
          ]}
        >
          <span>
            {obj.type == 'child' && (
              <span className="station-shoppingcart-icon" alt="ordered-status" onClick={(e) => toggleOrdered(obj)}>
                <ShoppingCartIcon needed={key === 0} ordered={key === 1} dimmed={false} />
              </span>
            )}
          </span>
        </RoleAccessibleComponent>
      ),
    },
  ];

  const columnTiles = [
    {
      title: () => {
        return <div>&#10003;</div>;
      },
      dataIndex: 'completed',
      sorter: (a, b) => (a.completed < b.completed ? -1 : a.completed > b.completed ? 1 : 0),
      sortDirections: ['descend', 'ascend'],
      width: 44,
      render: (key, obj) => (
        <span>
          {/* {obj.type == 'child' && (
            <span>
              {' '}
              <img
                alt="completed"
                height="38"
                onClick={(e) => toggleCompleted(e, obj)}
                src={obj.completed === 2 ? completed3 : completed1}
              />
            </span>
          )} */}
        </span>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'tags',
      sorter: (a, b) => (a.tags.name < b.tags.name ? -1 : a.tags.name > b.tags.name ? 1 : 0),
      sortDirections: ['descend', 'ascend'],
      render: (key, obj) => (
        <span className="name-key">
          {obj.type == 'child' && (
            <div style={{ display: 'flex' }}>
              {key.map((c) => {
                return (
                  <div className="ing-name-box21">
                    <div className="ing-name-panel-12"></div>
                    <div className="ing-name-panel">
                      <div className="ing-name1">{c.name}</div>
                      <div className="ing-infoPanel">
                        <span>
                          {obj.type == 'child' && (
                            <span className="station-checkmark-icon" onClick={() => setCompleteTaskTile(obj, true)}>
                              <CompletionIcon completed={obj.complete === 2} dimmed={false} />
                            </span>
                          )}
                          {/* {obj.type == 'child' && assignedToMe == 2 && (
                            <span>
                              {' '}
                              <img
                                alt="completed"
                                height="36"
                                onClick={() => setCompleteTaskTile(obj, true)}
                                src={c.complete === 2 ? completed : unselected2}
                                style={{ cursor: 'pointer' }}
                              />
                            </span>
                          )}
                          {obj.type == 'child' && assignedToMe == 1 && (
                            <span>
                              {' '}
                              <img
                                alt="completed"
                                height="36"
                                src={c.complete === 2 ? unselected1 : incomplete}
                                style={{ cursor: 'not-allowed' }}
                              />
                            </span>
                          )} */}
                        </span>
                        <span>
                          {c.texts > 0 ? <span className="texts1">{c.texts}</span> : ''}
                          {c.texts > 0 ? (
                            <span className="texts-icon">
                              {' '}
                              <img src={attach} className="comment" alt="comment" />
                            </span>
                          ) : (
                            ''
                          )}
                          {c.attachments > 0 ? (
                            <span className={c.texts > 0 ? 'comment1' : 'comment1'}>{c.attachments}</span>
                          ) : (
                            ''
                          )}
                          {c.attachments > 0 ? (
                            <span className={'texts-icon'}>
                              {' '}
                              <img src={attach} className="comment" alt="attach" />
                            </span>
                          ) : (
                            ''
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {obj.type == 'parent' && (
            <span className="row-parent-title">
              {obj.name} <div className="station-ing-totals">( {obj.ingredients} items )</div>
            </span>
          )}
        </span>
      ),
    },
  ];

  const updateStationIngredient = (fetchParams, ingredient, mappedUpdates) => {
    let clonedStationIngs = cloneDeep(pristineIngs);
    const ingredientIndex = findIndex(
      clonedStationIngs,
      (ing) =>
        ing.ingredientId === ingredient.ingredientId &&
        ing.recipeId === ingredient.recipeId &&
        ing.courseId === ingredient.courseId &&
        ing.menuId === ingredient.menuId
    );
    if (ingredientIndex > -1) {
      mappedUpdates.forEach((pair) => {
        const key = pair.key,
          value = pair.value;
        clonedStationIngs[ingredientIndex][key] = value;
      });
      setPristineIngs(clonedStationIngs);

      updateChecklist(fetchParams)
        .then((res) => {
          //
          // notification.open({
          //   message: 'Successfully deactivated!',
          // });
          setTimeout(() => {
            updateIngredientsState(true);
          }, 1000);
        })
        .catch((err) => console.log(err));
    }
  };

  const toggleHealth = (checked, obj) => {
    let newValue = obj.healthCheck === 1 ? 2 : 1;
    let prepIng = {
      healthCheck: newValue,
      completed: obj.completed,
      ordered: obj.ordered,
      setDate: obj.setDate,
      setTime: obj.setTime,
      setBy: obj.setBy,
      quantity: obj.ingredientQty,
      cost: 0, // this is temporary, API will be updated to accomodate this field
      order: obj.ingredientOrder,
      originalQty: obj.ingredientQty,
    };
    let params = {
      menuId: obj.menuId,
      recipeId: obj.recipeId,
      ingredientId: obj.ingredientId,
      preparationId: obj.preparationId,
      measurementId: obj.measurementId,
      info: prepIng,
    };

    if (stationType === 'event') {
      params.eventId = stationId;
    }

    if (stationType === 'kitchen') {
      params.stationId = stationId;
    }

    updateStationIngredient(params, obj, [{ key: 'healthCheck', value: newValue }]);
  };

  const toggleCompleted = (checked, obj) => {
    let newValue = obj.completed === 1 ? 2 : 1;
    let prepIng = {
      healthCheck: obj.healthCheck,
      completed: newValue,
      ordered: obj.ordered,
      setDate: obj.setDate,
      setTime: obj.setTime,
      setBy: obj.setBy,
      quantity: obj.ingredientQty,
      cost: 0, // this is temporary, API will be updated to accomodate this field
      order: obj.ingredientOrder,
      originalQty: obj.ingredientQty,
    };
    let params = {
      menuId: obj.menuId,
      recipeId: obj.recipeId,
      ingredientId: obj.ingredientId,
      preparationId: obj.preparationId,
      measurementId: obj.measurementId,
      info: prepIng,
    };

    if (stationType === 'event') {
      params.eventId = stationId;
    }

    if (stationType === 'kitchen') {
      params.stationId = stationId;
    }

    updateStationIngredient(params, obj, [{ key: 'completed', value: newValue }]);
  };

  const updateIngredientOrderStatus = (obj, newStatus) => {
    // UPDATE STATION CHECKLIST
    let prepIng = {
      healthCheck: obj.healthCheck,
      completed: obj.completed,
      ordered: newStatus.toString(),
      setDate: obj.setDate,
      setTime: obj.setTime,
      setBy: obj.setBy,
      quantity: obj.ingredientQty,
      cost: 0, // this is temporary, API will be updated to accomodate this field,
      order: obj.ingredientOrder,
      originalQty: obj.ingredientQty,
    };

    let toChecklistParams = {
      menuId: obj.menuId,
      recipeId: obj.recipeId,
      ingredientId: obj.ingredientId,
      preparationId: obj.preparationId,
      measurementId: obj.measurementId,
      info: prepIng,
    };

    if (stationType === 'event') {
      toChecklistParams.eventId = stationId;
    }

    if (stationType === 'kitchen') {
      toChecklistParams.stationId = stationId;
    }

    updateStationIngredient(toChecklistParams, obj, [{ key: 'ordered', value: newStatus }]);
  };

  const toggleOrdered = (obj) => {
    let newStatus;
    if (obj.ordered == -1) {
      newStatus = 0;
    } else if (obj.ordered == 0) {
      newStatus = 1;
    } else if (obj.ordered == 1) {
      newStatus = -1;
    }

    // ADD / UPDATE SHOPPING LIST
    // if ingredient is not in shopping list, ADD
    if (obj.ordered == -1) {
      const currentDate = new Date() * 1;
      let toShoplistParams = {
        operatorId: (JSON.parse(localStorage.getItem('operator')) || {}).id,
        stationId: stationType === 'kitchen' ? stationId : null, // this is temporary
        eventId: stationType === 'event' ? stationId : null, // this is temporary
        ingredientId: obj.ingredientId,
        ingredientCategoryId: obj.categoryId,
        restaurantId: restaurantId,
        ordered: 0,
        dateTime: currentDate,
      };

      addItemToShop(toShoplistParams)
        .then((res) => {
          if (res?.results?.id) {
            obj.shoplistId = res.results.id;
            updateIngredientOrderStatus(obj, newStatus);
          } else {
            return;
          }
        })
        .catch((err) => console.log(err));

      // else, update the status
    } else {
      const currentDate = new Date() * 1;
      let changeStatParams = {
        operatorId: (JSON.parse(localStorage.getItem('operator')) || {}).id,
        dateUpdated: currentDate.toString(),
      };

      if (newStatus > 0) {
        itemOrdered(obj.shoplistId.toString(), changeStatParams)
          .then((res) => {
            if (res.id === obj.shoplistId) {
              updateIngredientOrderStatus(obj, newStatus);
            }
          })
          .catch((err) => console.log(err));
      } else {
        deleteItem(obj.shoplistId.toString())
          .then((res) => {
            updateIngredientOrderStatus(obj, newStatus);
          })
          .catch((err) => console.log(err));
      }
    }
  };

  const setActiveDay = (obj) => {
    let today = moment().format('YYYY-MM-DD');
    let todayTime = moment().format('LT');
    let prepIng = {
      healthCheck: obj.healthCheck,
      completed: obj.completed,
      ordered: obj.ordered.toString(),
      setDate: today,
      setTime: todayTime,
      setBy: userInfo.firstName + ' ' + userInfo.lastName,
      quantity: obj.ingredientQty,
      cost: 0, // this is temporary, API will be updated to accomodate this field,
      order: obj.ingredientOrder,
      originalQty: obj.ingredientQty,
    };
    let params = {
      menuId: obj.menuId,
      recipeId: obj.recipeId,
      ingredientId: obj.ingredientId,
      preparationId: obj.preparationId,
      measurementId: obj.measurementId,
      info: prepIng,
    };

    if (stationType === 'event') {
      params.eventId = stationId;
    }

    if (stationType === 'kitchen') {
      params.stationId = stationId;
    }

    updateStationIngredient(params, obj, [
      { key: 'day', value: moment(today).format('dddd') },
      { key: 'setDate', value: today },
      { key: 'setTime', value: todayTime },
      { key: 'setBy', value: `${userInfo.firstName} ${userInfo.lastName}` },
    ]);
  };

  const unsetDay = (obj) => {
    //
    let prepIng = {
      healthCheck: obj.healthCheck,
      completed: obj.completed,
      ordered: obj.ordered.toString(),
      setDate: '',
      setTime: '',
      setBy: '',
      quantity: obj.ingredientQty,
      cost: 0, // this is temporary, API will be updated to accomodate this field,
      order: obj.ingredientOrder,
      originalQty: obj.ingredientQty,
    };
    let params = {
      menuId: obj.menuId,
      recipeId: obj.recipeId,
      ingredientId: obj.ingredientId,
      preparationId: obj.preparationId,
      measurementId: obj.measurementId,
      info: prepIng,
    };

    if (stationType === 'event') {
      params.eventId = stationId;
    }

    if (stationType === 'kitchen') {
      params.stationId = stationId;
    }

    updateStationIngredient(params, obj, [
      { key: 'day', value: 'Invalid date' },
      { key: 'setDate', value: '' },
      { key: 'setTime', value: '' },
      { key: 'setBy', value: '' },
    ]);
  };

  const resetDefaultSort = () => {
    setSortedInfo(null);
  };

  const handleChange = (pagination, filters, sorter) => {
    console.log('Various parameters', pagination, filters, sorter);
    if (sorter.order) {
      setSortedInfo(sorter);
    } else {
      setSortedInfo(null);
    }
  };

  useEffect(() => {
    if (sortedInfo == null) {
      let taskOrder = JSON.parse(localStorage.getItem('stationOrder'));
      if (taskOrder) {
        console.log(taskOrder);
        setSelectedList2(taskOrder);
      }
    }
  }, [sortedInfo]);

  const clearStation = () => {
    let stationIngs = cloneDeep(pristineIngs);

    let filterStations = [].concat.apply([], stationIngs);

    const fetchData = () => {
      // let prep = { healthCheck: 1, completed: 1, needed: 1, setDate: '', setTime: '', setBy: '' };
      const allRequests = filterStations.map((obj) => {
        const params = {
          menuId: obj.menuId,
          recipeId: obj.recipeId,
          ingredientId: obj.ingredientId,
          preparationId: obj.preparationId,
          measurementId: obj.measurementId,
          info: {
            healthCheck: 1,
            completed: 1,
            ordered: parseInt(obj?.ordered) != null ? obj.ordered : -1,
            setDate: obj?.setDate ? obj.setDate : 'unset',
            setTime: obj?.setTime ? obj.setTime : 'unset',
            setBy: obj?.setBy ? obj.setBy : 'unset',
            cost: 0,
            originalQty: obj?.originalQty ? obj.originalQty : 0,
            quantity: obj?.quantity ? obj.quantity : 0,
            order: obj.order
          },
        }

        if (stationType === 'kitchen') {
          params.stationId = stationId;
        }

        if (stationType === 'event') {
          params.eventId = stationId;
        }

        updateChecklist(params).then((response) => response)

      });

      // const removeShoppingLists = removeFromShop(stationType, stationId).then((response) => response);

      return Promise.all([...allRequests]);
    };

    fetchData().then((res) => {
      console.log('CLEARED ALL', res);
      // notification.open({
      //   message: 'Successfully cleared station!',
      // });
      let updatedTableData = cloneDeep(pristineIngs).map((item) => {
        item.healthCheck = 1;
        item.completed = 1;
        item.ordered = parseInt(item?.ordered) != null ? item.ordered : -1;
        item.shoplistId = parseInt(item?.shoplistId) != null ? item.shoplistId : 0;
        item.setDate = item?.setDate ? item.setDate : '';
        item.day = item?.setDate && item.setDate !== 'unset' ? moment(item.setDate).format('dddd') : 'Invalid date';
        item.setTime = item?.setTime ? item.setTime : 'unset';
        item.setBy = item?.setBy ? item.setBy : 'unset';
        return item;
      });
      setPristineIngs(updatedTableData);
      setTimeout(() => {
        updateIngredientsState(true);
      }, 1000);
    });
  };

  const setCompleteTask = (obj, isComplete) => {
    console.log(obj);
    const id = obj.key;
    const clonedChecklist = cloneDeep(selectedList2);
    console.log(clonedChecklist);
    const foundIndex = findIndex(clonedChecklist, { key: obj.parentId });
    const foundChildIndex = findIndex(clonedChecklist[foundIndex]?.children, { key: obj.key });
    const checkItem = clonedChecklist[foundIndex]?.children[foundChildIndex];

    const iteminfo = {
      checked: checkItem.complete !== 2 ? checkItem.checked : !checkItem.checked,
      complete: checkItem.complete !== 2 ? 2 : 1,
      description: checkItem.description,
      details: checkItem.details,
      tags: checkItem.tags,
    };

    console.log(iteminfo.complete);
    updateItem(id, { info: iteminfo }).then((res) => {
      localStorage.removeItem('openRecipePanelStations');
      // notification.open({
      //   message: 'Successfully updated task! Loading updated data...',
      // });
      if (!hasUpdateChecklist) {
        setHasUpdate(true);
        // setEventChecklistFiltered(true);
        eventSocket.emit(
          'updateStationTask',
          JSON.stringify({
            id: id,
          })
        );
      } else {
        setTimeout(() => {
          updateTaskState({ type: 'filter', id: obj.keyId });
        }, 1000);
        clonedChecklist[foundIndex].children[foundChildIndex].complete = iteminfo.complete;
        console.log(clonedChecklist);
        setSelectedList2(clonedChecklist);
      }
    });
  };

  const setCompleteTaskTile = (obj, isComplete) => {
    console.log(obj);
    const clonedChecklist = cloneDeep(selectedList);
    const foundIndex = findIndex(clonedChecklist, { key: obj.parentId });
    const foundChildIndex = findIndex(clonedChecklist[foundIndex]?.children, { key: obj.key });
    const checkItem = clonedChecklist[foundIndex]?.children[foundChildIndex];

    const foundTagIndex = findIndex(
      checkItem.tags,
      (e) => {
        return e.parentId == obj.parentId;
      },
      0
    );

    const tagItems = clonedChecklist[foundIndex]?.children[foundChildIndex].tags[foundTagIndex];

    const id = tagItems.key;

    const iteminfo = {
      checked: tagItems.complete !== 2 ? tagItems.checked : !tagItems.checked,
      complete: tagItems.complete !== 2 ? 2 : 1,
      description: tagItems.description,
      details: tagItems.details,
      tags: tagItems.tagsList,
    };

    console.log(id, iteminfo);

    updateItem(id, { info: iteminfo }).then((res) => {
      localStorage.removeItem('openRecipePanelStations');
      // notification.open({
      //   message: 'Successfully updated task! Loading updated data...',
      // });
      setTimeout(() => {
        updateTaskState({ type: 'filter', id: obj.keyId });
      }, 1000);
      clonedChecklist[foundIndex].children[foundChildIndex].complete = iteminfo.complete;
      setSelectedList(clonedChecklist);
    });
  };

  const closeDrawer = useCallback((data) => {
    updateVisible(false);
    updateVisible1(false);
    updateIngredientsState(true);
    updateDocumentsState(true);
  }, []);

  const showDrawer = () => {
    if (stationType === 'event') {
      updateVisible1(true);
      setDocLinks1({
        type: 'events',
        linkId: stationId,
      });
      setLinks1({
        type: 'events',
        linkId: stationId,
        info: { title: stationName },
      });
    } else {
      updateVisible(true);
      setDocLinks({
        type: 'kitchen',
        linkId: stationId,
      });
      setLinks({
        type: 'kitchen',
        linkId: stationId,
        info: { title: stationName },
      });
    }
  };

  const onClose = () => {
    updateVisible(false);
    updateVisible1(false);
  };

  return (
    <div>
      {activateChecklists ? (
        /* shows filtered checklists */
        <div className="common-controls-container controls-thin">
          <div className="station-filtered-recipe-container flex-control-left">
            <ThumbnailImage
              className="station-recipe-image-container"
              type={'cover'}
              src={selectedList[0]?.image ? selectedList[0]?.image : null}
              placeholderIcon={<CookbookIcon />}
            />
            <div>
              <Link
                to={{
                  pathname: `/checklist`,
                  selectedId: selectedId,
                }}
              >
                <div className="selected-recipe-title" title="View checklist">
                  {selectedList[0]?.name}
                </div>
              </Link>
              <div>
                ( {selectedList[0]?.children[0]?.tags?.length !== 0 ? selectedList[0]?.children[0]?.tags?.length : '0'}{' '}
                items )
              </div>
            </div>
          </div>
          <AttachmentIndicator className="flex-control-right" count={documents} onClick={showDrawer} />
          {/* <div>
            {stationDetail.attachments}
            <img src={attach} className="station-attach-menu" alt="attachment" />
          </div> */}
          <CidekicDropdown overlay={menu1} className="flex-control select-wide" trigger={['click']}>
            {menuName ? menuName : 'All items'}
          </CidekicDropdown>
          {/* <div className="station-tableview" onClick={() => setShowTiles(true)}>
            Tiles
          </div>
          <div className="station-tableview" onClick={() => setShowTiles(false)}>
            List
          </div> */}
        </div>
      ) : (
        /* shows filtered recipes instead */
        <div className="common-controls-container controls-thin">
          <div className="station-filtered-recipe-container flex-control-left">
            <ThumbnailImage
              className="station-recipe-image-container"
              type={'cover'}
              src={tableData.length > 0 && tableData[0]?.recipeImage !== '' ? tableData[0].recipeImage : null}
              placeholderIcon={<CookbookIcon />}
            />
            <div>
              <Link
                to={{
                  pathname: tableData.length > 0 ? `/recipes/view/${tableData[0]?.recipeId}` : '',
                  state: {
                    from: stationType === 'event' ? 'event' : 'station',
                    menuid: tableData.length > 0 ? tableData[0]?.menuId: 0,
                    stationId: stationId,
                  },
                }}
              >
                <div className="selected-recipe-title" title="View recipe">
                  {tableData.length > 0 && tableData[0]?.recipeName}
                </div>
              </Link>
              <div>( {tableData.length ? tableData.length : '0'} Ingredients )</div>
            </div>
          </div>
          <RoleAccessibleComponent
            permittedRoles={['Chef', 'Admin', 'Superadmin', 'Client Admin', 'Dev Team', 'Account Holder']}
          >
            <CidekicButton className="flex-control-mid button-transparent" onClick={clearStation}>
              Clear Station
            </CidekicButton>
          </RoleAccessibleComponent>
          <AttachmentIndicator className="flex-control-right" count={documents} onClick={showDrawer} />
          {/* <div>
            {stationDetail.attachments}
            <img src={attach} className="station-attach-menu" alt="attachment" />
          </div> */}
          <CidekicDropdown overlay={menu} className="flex-control select-wide" trigger={['click']}>
            {menuName ? menuName : 'All ingredients'}
          </CidekicDropdown>
        </div>
      )}
      <div onClick={resetDefaultSort} className="reset-displayStation">
        Reset display
      </div>
      {activateChecklists ? (
        <div className="station-table-filtered station-checklist">
          <Table
            columns={showTiles ? columnTiles : columnChecklist}
            dataSource={showTiles ? selectedList[0]?.children : selectedList2[0]?.children}
            pagination={false}
            scroll={{ y: `calc(100vh - var(--station-filtered-scroll-offset${progressOpen ? '' : '-closed'}))` }}
            onChange={handleChange}
          />
        </div>
      ) : (
        <div className="station-table-filtered">
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={false}
            scroll={{ y: `calc(100vh - var(--station-filtered-scroll-offset${progressOpen ? '' : '-closed'}))` }}
            onChange={handleChange}
            rowKey={'rowKey'}
          />
        </div>
      )}
      <Drawer
        width={windowSize.width > 800 ? '850px' : '100%'}
        onClose={onClose}
        visible={visible}
        closable={false}
        drawerStyle={{ backgroundColor: 'var(--main-fill)' }}
      >
        <DocumentList
          windowSize={windowSize}
          closeDrawer={closeDrawer}
          docLinks={docLinks}
          links={links}
          documentsIn="kitchen"
        />
      </Drawer>
      {/* events */}
      <Drawer
        width={windowSize.width > 800 ? '850px' : '100%'}
        onClose={onClose}
        visible={visible1}
        closable={false}
        drawerStyle={{ backgroundColor: 'var(--main-fill)' }}
      >
        <DocumentList
          windowSize={windowSize}
          closeDrawer={closeDrawer}
          docLinks={docLinks1}
          links={links1}
          documentsIn="events"
        />
      </Drawer>
    </div>
  );
};

export default StationFiltered;
